import { gql } from '@apollo/client';

export const UPDATE_JOBSITE_WORKER = gql`
  mutation UpdateJobsiteWorker(
    $jobsiteWorkerId: ID!
    $jobsiteWorkerInput: JobsiteWorkerInput!
  ) {
    updateJobsiteWorker(
      jobsiteWorkerId: $jobsiteWorkerId
      jobsiteWorkerInput: $jobsiteWorkerInput
    ) {
      orientationDate
    }
  }
`;
